import { KOREA_DISTRICTS_BY_REGION } from './koreaRegions';

export const HOME_HOT_POSTS = [
  {
    author: 'happytree12',
    category: '궁금해요',
    comments: 15,
    image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&w=900&q=80',
    likes: 212,
    title: '보컬용 이펙터 어떤게 제일 좋나요? 추천해주세요!',
  },
  {
    author: '연습집중중',
    category: '궁금해요',
    comments: 13,
    image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&w=900&q=80',
    likes: 117,
    title: '보컬 연습하기 좋은 연습실 추천해주세요! 🎤',
  },
  {
    author: 'neowmeow',
    category: '공간리뷰',
    comments: 10,
    image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&w=900&q=80',
    likes: 110,
    title: '홍대 합주실 다녀온 후기 - 가성비 만족 👍',
  },
  {
    author: 'BandSoul33',
    category: '공간리뷰',
    comments: 31,
    image: 'https://images.unsplash.com/photo-1519892300165-cb5542fb47c7?auto=format&fit=crop&w=900&q=80',
    likes: 109,
    title: '방음 괜찮은 보컬 연습실 찾는 분들 참고하세요',
  },
];

export const HOME_SPACE_CARDS = [
  {
    detailPath: '/spaces/yeongchang-upright-room',
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=1200&q=80',
    location: '서울 마포구 동교동',
    price: '15,000원',
    rating: '4.9',
    studio: '서울스트리트퍼포먼스',
    subtitle: '합주실',
    title: '영창 업라이트 피아노 연습실',
  },
  {
    detailPath: '/spaces/a-room-grand-piano-rental',
    image: 'https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?auto=format&fit=crop&w=1200&q=80',
    location: '서울 마포구 서교동',
    price: '10,000원',
    rating: '5.0',
    studio: '업비트스튜디오',
    subtitle: '합주실',
    title: 'A룸 그랜드 피아노 대관',
  },
  {
    detailPath: '/spaces/jazz-ensemble-room',
    image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&w=1200&q=80',
    location: '서울 마포구 동교동',
    price: '13,000원',
    rating: '4.5',
    studio: '예쎄뮤직',
    subtitle: '합주실',
    title: '재즈 합주실',
  },
  {
    detailPath: '/spaces/yamaha-u3-room',
    image: 'https://images.unsplash.com/photo-1519892300165-cb5542fb47c7?auto=format&fit=crop&w=1200&q=80',
    location: '서울 마포구 신수동',
    price: '14,000원',
    rating: '4.4',
    studio: '자하브합주실',
    subtitle: '합주실',
    title: '야마하 U3 피아노 연습실',
  },
  {
    detailPath: '/spaces/room-black',
    image: 'https://images.unsplash.com/photo-1507838153414-b4b713384a76?auto=format&fit=crop&w=1200&q=80',
    location: '서울 마포구 연남동',
    price: '10,000원',
    rating: '4.5',
    studio: '프롬스튜디오',
    subtitle: '합주실',
    title: 'Room Black',
  },
  {
    detailPath: '/spaces/jazz-big-room',
    image: 'https://images.unsplash.com/photo-1487180144351-b8472da7d491?auto=format&fit=crop&w=1200&q=80',
    location: '서울 마포구 연남동',
    price: '18,000원',
    rating: '4.9',
    studio: '준사운드',
    subtitle: '합주실',
    title: '재즈합주실/앙상블실',
  },
  {
    detailPath: '/spaces/room-b-u1',
    image: 'https://images.unsplash.com/photo-1508780709619-79562169bc64?auto=format&fit=crop&w=1200&q=80',
    location: '서울 마포구 망원동',
    price: '14,000원',
    rating: '4.6',
    studio: '순스튜디오',
    subtitle: '합주실',
    title: '[ROOM B] 야마하 업라이트 U1',
  },
  {
    detailPath: '/spaces/upright-room-2',
    image: 'https://images.unsplash.com/photo-1526142684086-7ebd69df27a5?auto=format&fit=crop&w=1200&q=80',
    location: '서울 마포구 염리동',
    price: '12,000원',
    rating: '4.8',
    studio: '타수 음악연습실',
    subtitle: '합주실',
    title: '업라이트 피아노 연습실 2번방',
  },
];

/** 메인 Figma(6049:3787) — 밴더 인기 합주실 원형 카테고리 */
export const HOME_CATEGORY_BUBBLES = [
  { accent: '#f1578f', label: '보컬/미디' },
  { accent: '#9d3ef6', label: '밴드/합주' },
  { accent: '#54c7f4', label: '댄스/연기' },
  { accent: '#c4a35a', label: '클래식/현악' },
  { accent: '#f28b2f', label: '피아노' },
  { accent: '#5c6bc0', label: '드럼' },
  { accent: '#7cb342', label: '현악/관악' },
  { accent: '#fb64b6', label: '기타/베이스' },
];

export const HOME_REVIEW_CARDS = [
  {
    author: 'mellowkeys',
    date: '2025.02.12',
    image: 'https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?auto=format&fit=crop&w=900&q=80',
    rating: '4.8',
    spaceName: '엔젤 업라이트 피아노 연습실',
    text: '피아노 상태가 좋아서 연습 집중도가 높았습니다. 예약도 빠르고 입실 절차가 깔끔했어요.',
  },
  {
    author: 'mixlab',
    date: '2025.02.08',
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=900&q=80',
    rating: '5.0',
    spaceName: 'A룸 그랜드 피아노 대관',
    text: '장비 구성이 명확해서 합주 리허설용으로 좋았습니다. 다음에도 같은 공간으로 재예약할 예정입니다.',
  },
  {
    author: 'vocalroom',
    date: '2025.02.03',
    image: 'https://images.unsplash.com/photo-1519892300165-cb5542fb47c7?auto=format&fit=crop&w=900&q=80',
    rating: '4.6',
    spaceName: '재즈 합주실',
    text: '방음이 안정적이고 조명이 편안해서 보컬 녹음 연습용으로 적합했습니다.',
  },
  {
    author: 'bandercrew',
    date: '2025.01.28',
    image: 'https://images.unsplash.com/photo-1508780709619-79562169bc64?auto=format&fit=crop&w=900&q=80',
    rating: '4.9',
    spaceName: 'Room Black',
    text: '게스트로 둘러보기에도 정보가 명확해서 공간 비교가 쉬웠습니다. 첫 예약 진입 장벽이 낮았어요.',
  },
];

// koreaRegions.ts 풀네임 → 홈 필터 단축 표기
const HOME_REGION_SHORT_NAMES: Record<string, string> = {
  서울특별시: '서울',
  부산광역시: '부산',
  대구광역시: '대구',
  인천광역시: '인천',
  광주광역시: '광주',
  대전광역시: '대전',
  울산광역시: '울산',
  세종특별자치시: '세종',
  경기도: '경기',
  강원특별자치도: '강원',
  충청북도: '충북',
  충청남도: '충남',
  전북특별자치도: '전북',
  전라남도: '전남',
  경상북도: '경북',
  경상남도: '경남',
  제주특별자치도: '제주',
};

// 좌/우 2단 컬럼 — 17개 시·도 전부 (특별·광역시+경기 / 도 단위). 누락 없도록 koreaRegions와 동일 범위.
export const HOME_FILTER_REGION_COLUMNS = {
  left: ['서울', '부산', '대구', '인천', '광주', '대전', '울산', '세종', '경기'],
  right: ['강원', '충북', '충남', '전북', '전남', '경북', '경남', '제주'],
} as const;

// 시·도별 전체 구/군 — koreaRegions.ts(KOREA_DISTRICTS_BY_REGION)를 단일 출처로 파생.
// (기존 목업은 시·도당 6~7개만 있어 서울 등 대부분 구가 누락돼 있었음)
export const HOME_FILTER_REGION_DISTRICTS: Record<string, string[]> = Object.fromEntries(
  Object.entries(KOREA_DISTRICTS_BY_REGION).map(([fullName, districts]) => [
    HOME_REGION_SHORT_NAMES[fullName],
    districts,
  ]),
);

export const HOME_FILTER_SPACE_OPTIONS = ['합주실', '연습실', '녹음실', '공연장'] as const;

export const HOME_FILTER_KEYWORD_GROUPS = [
  {
    label: '공간 유형',
    options: ['#합주실', '#연습실', '#레슨실', '#녹음실', '#공연연습실', '#버스킹 준비 공간'],
  },
  {
    label: '악기/장비',
    options: [
      '#그랜드 피아노',
      '#업라이트 피아노',
      '#드럼 세트',
      '#일렉기타 앰프',
      '#베이스 앰프',
      '#PA 시스템',
      '#오디오 인터페이스',
      '#보컬 마이크',
    ],
  },
  {
    label: '편의시설',
    options: ['#주차 가능', '#좌석형 있음', '#냉난방 완비', '#방음 시설', '#휴게 공간', '#와이파이 제공'],
  },
  {
    label: '운영/서비스',
    options: ['#24시간 운영', '#당일 예약', '#셀프 입실', '#샤워실', '#화장실 분리', '#락커 제공'],
  },
] as const;
